import _ from 'lodash'

export default {
    computed: {
        organizationSlug() {
            let organizationSlug = this.$route.params.organization_slug

            if (organizationSlug) {
                organizationSlug = organizationSlug.toLowerCase()
                return _.includes(this.organizationSlugWhitelist, organizationSlug) ? '' : organizationSlug
            }

            return ''
        },
    },

    data() {
        return {
            organizationSlugWhitelist: [
                '404',
                'auth',
                'login',
                'logout',
                'forgot-password',
                'onboarding',
                'organizations',
                'firmware',
                'mobile-features',
                'device-whitelist',
                'gokit-updates',
            ],
        }
    },
}
